import { render, staticRenderFns } from "./SplitDocument.vue?vue&type=template&id=0733c158&scoped=true&"
import script from "./SplitDocument.vue?vue&type=script&lang=js&"
export * from "./SplitDocument.vue?vue&type=script&lang=js&"
import style0 from "./SplitDocument.vue?vue&type=style&index=0&id=0733c158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733c158",
  null
  
)

export default component.exports